import API_CONSTRUCTOR from "./api-model";
import PropertyAPIs from "./property";
import ChatbotAPIs from "./chatbot";
import AuthAPIs from "./auth";

// Create API instance
const API = API_CONSTRUCTOR();

// Export individual API instances
export const propertyAPI = new PropertyAPIs(API);
export const chatbotAPI = new ChatbotAPIs(API);
export const authAPI = new AuthAPIs(API);

// Export for creating custom instances if needed
export { API_CONSTRUCTOR, PropertyAPIs, ChatbotAPIs, AuthAPIs };
export { BASE_URL } from "./config";
